<template lang="pug">
ValidationProvider(:rules="rules" :name="name || label" ref="provider" v-slot="{ errors }" tag="div").form

  label.form-label.u-mt-ts Your Phone Number
  .input-group
    Multiselect(
      v-model="country"
      @select="$refs.input.focus()"
      :options="countries"
      :showLabels="false"
      :custom-label="c => `${c.name} (+${c.dialCode})`"
      track-by="iso2"
    )
      template(#singleLabel="{ option }")
        span(:class="`flag-icon flag-icon-${option.iso2.toLowerCase()}`")
        span(style="margin-left: 5px; margin-right: 5px;") (+{{ option.dialCode }})
      template(#option="{ option }")
        span(:class="`flag-icon flag-icon-${option.iso2.toLowerCase()}`")
        span(style="margin-left: 5px; margin-right: 5px;") (+{{ option.dialCode }})
    input.input(@input="phone.number = $event.target.value" :value="phone.number" :class="{ 'has-error': !!errors[0] }" ref="input")
  transition(name="validation")
    p(v-if="errors[0]").form-error {{ errors[0] }}
</template>

<script>
import Multiselect from 'vue-multiselect';
import { ValidationProvider } from 'vee-validate';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'flag-icon-css/css/flag-icon.min.css';
import countries from '@/data/countries';

export default {
  name: 'PhoneInput',
  components: {
    Multiselect,
    ValidationProvider
  },
  props: {
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    value: {
      type: null,
      default: ''
    },
    rules: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    countries,
    country: '',
    intereactedWith: {
      country: false,
      phoneInput: false
    },
    phone: {
      number: '',
      dialCode: '',
      country: ''
    }
  }),
  watch: {
    value (val) {
      if (val !== this.stringifyValue(this.phone)) {
        this.phone = this.parseValue(val);
      }
    },
    phone: {
      deep: true,
      handler (val) {
        if (val.number) {
          this.intereactedWith.phoneInput = true;
        }
        if (!this.intereactedWith.phoneInput || !this.intereactedWith.country) {
          return;
        }

        const value = this.stringifyValue(val);
        this.$refs.provider.validate(value);
        this.$emit('input', value);
      }
    },
    country (val) {
      this.intereactedWith.country = true;
      this.phone.dialCode = (val && val.dialCode) || '';
    }
  },
  created () {
    if (!this.value) {
      return;
    }

    this.phone = this.parseValue(this.value);
    this.country = this.countries.find(c => this.phone.country === c.iso2);
  },
  methods: {
    parseValue (value) {
      const country = this.countries.find(c => value.startsWith(`+${c.dialCode}`));
      if (!country) {
        return { number: '', dialCode: '', country: '' };
      }

      return {
        number: value.replace(`+${country.dialCode}`, ''),
        country: country.iso2,
        dialCode: country.dialCode
      };
    },
    stringifyValue (value) {
      if (!value.dialCode || !value.number) {
        return '';
      }

      return `+${value.dialCode}${value.number}`;
    }
  }
};
</script>

<style lang="stylus">
.input-group
  display: flex

  .multiselect
    max-width: 200px
</style>
